import React from 'react';
import { VisitorTabCardApp } from '../Functionality/VisitorTabCardApp';
import VisitorCard from './VisitorCard';
import VisitorMainHeader from './VisitorMainHeader';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const VisitorTabCard = (props) => {
    const {
        selectedList,
        setSelectedList,
        view,
        setView,
        searchElement,
        setSearchElement,
        setBodyForExport,
        finalArray,
        setFinalArray,
        search,
        setSearch,
        goUpdate,
        viewOrigin,
        setShowRequestAccessModal,
        getChildrenNotInformation,
        subView,
        handleSubViewChange,
        searchId,
        setSearchResults,
        setCriteria,
        modified,
        setModified,
        setIsAllChecked,
        setSimpleSearch
    } = props;

    const {
        DEV,
        permission,
        results,
        setResults,
        option,
        rowsPerPage,
        elementRefTab1,
        pagination,
        handleCheckboxChange
    } = VisitorTabCardApp({
        selectedList,
        setSelectedList,
        setCriteria,
        searchElement,
        finalArray,
        modified,
        setModified,
        setBodyForExport,
        setIsAllChecked
    });

    return (
        <>
            <VisitorMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray}
                permission={permission}
                DEV={DEV}
                view={view}
                setView={setView}
                setResults={setResults}
                viewOrigin={viewOrigin}
                setIsAllChecked={setIsAllChecked}
                setCriteria={setCriteria}
            />

            <div className='panelTables px-1 row' ref={elementRefTab1}>
                {results?.content?.length === 0 ? (
                   getChildrenNotInformation()
                ) : (
                    results?.content?.map((item) => (
                        <div className='col-sm-6 col-md-4 col-lg-3 col-xl-3 mb-3'>
                            <VisitorCard
                                item={item}
                                selectedList={selectedList}
                                setSelectedList={setSelectedList}
                                handleCheckboxChange={handleCheckboxChange}
                                goUpdate={goUpdate}
                                setShowRequestAccessModal={setShowRequestAccessModal}
                                viewOrigin={viewOrigin}
                            />
                        </div>
                    ))
                )}
            </div>
            {pagination()}
        </>
    );
};

export default VisitorTabCard;
